export default "__VITE_ASSET__BUv$zSWV__"